import { render } from "./index.vue?vue&type=template&id=da965e94&scoped=true"
import script from "./Card.js?vue&type=script&lang=js"
export * from "./Card.js?vue&type=script&lang=js"

import "./Card.scss?vue&type=style&index=0&id=da965e94&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-da965e94"

export default script